import { logAndNotifyError, logDebugSilently } from "../modules/logger";
import Notify from "devextreme/ui/notify";

// @import url("../node_modules/ace-builds/css/ace.css");
// @import url("../node_modules/ace-builds/css/theme/dreamweaver.css");
// @import url("../node_modules/ace-builds/css/theme/ambiance.css");
// @import url("../node_modules/devextreme/dist/css/dx.carmine.css");
import { ChangeEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { get, getUserInfo, post } from "../modules/server";
import { Alert, Button, Card, Row, Table } from "react-bootstrap";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { EventInfo } from "devextreme/events";
import { DataGrid, List } from "devextreme-react";
import { OptionChangedEventInfo } from "devextreme/core/dom_component";

import ArrayStore from "devextreme/data/array_store";
import dxDataGrid, { EditingStartEvent, NewRowInfo, RowDblClickEvent } from "devextreme/ui/data_grid";
import { Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { useForm } from "react-hook-form";
import ValidationSummaryMessages from "../components/Configuration/ValidationSummaryMessages";
import TextEditor from "../components/Global/Editors/TextEditor";
import { useNavigate } from "react-router-dom";
import Abonnemang from "../components/Abonnemang";
import { useGlobalData } from "../components/GlobalDataProvider";
import { faYenSign } from "@fortawesome/free-solid-svg-icons";
import { IAbonnemang } from "../types/ModuleDatas";
import { AnyRecord } from "dns";
import CheckboxEditor from "../components/Global/Editors/CheckboxEditor";
import { Colors } from "../modules/Colors";

const ChangeAbonnemang = () => {
  const formHookCurrent = useForm({ defaultValues: {} as any });
  const formHookNew = useForm({ defaultValues: {} as any });
  const [currentHousingStock, setCurrentHousingStock] = useState({} as any);
  const navigate = useNavigate();
  const [priceDiff, setPriceDiff] = useState(null as any);
  const [licenceExpirationDate, setLicenceExpirationDate] = useState(null as any);
  const ref = useRef(null as any);

  const noOfBuildings = formHookNew.watch("noOfBuildings");
  const totalSurfaceArea = formHookNew.watch("totalSurfaceArea");

  const canUpdateSubscription = currentHousingStock && currentHousingStock.noOfBuildings <= noOfBuildings && currentHousingStock.totalSurfaceArea <= totalSurfaceArea;

  useEffect(() => {
    (async () => {
      const response = await get("GetCurrentSubscription"); //
      if (response.success) {
        formHookCurrent.reset(response.subscription);
        formHookNew.reset(response.subscription);
        setLicenceExpirationDate(response.subscription.licenceExpirationDate ? new Date(response.subscription.licenceExpirationDate) : null);
        const curSubResp = await get("GetCurrentHousingStock");
        if (curSubResp.success) {
          setCurrentHousingStock(curSubResp.housingStock);
        }
      } else {
        Notify(response.message, "error");
      }
    })();
  }, [formHookCurrent, formHookNew]);

  const {
    handleSubmit,
    formState: { errors },
  } = formHookNew;

  const hasErrors = Object.keys(errors).length > 0;

  const onCancel = () => {
    navigate(-1);
  };

  if (ref.current === null) {
    ref.current = {};
  }
  const onTestGetPrice = () => {
    if (ref.current.getPrice) {
      logDebugSilently(ref.current.getPrice());
    }
  };

  const onSubmit = async (data: any) => {
    const response = await post("SaveSubscriptionUpdate", data);
    if (response.success) {
      Notify("Ändringarna har sparats", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else Notify("Ändringarna kunde inte sparas - " + response.message, "error");
  };

  const numberFormatter = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 });

  const onPriceChange = async (price: number) => {
    const response = await post("GetSubscriptionUpdate", { noOfBuildings, totalSurfaceArea });
    if (response.success) {
      setPriceDiff(response.priceInfo);
    }
  };

  // if (ref.current?.hookNew?.getPrice && ref.current?.hookCurrent?.getPrice) {
  //   const curPrice = ref.current.hookCurrent.getPrice();
  //   const newPrice = ref.current.hookNew.getPrice();

  //   if (curPrice !== newPrice) {
  //     console.log("Price has changed");
  //   }
  // }

  const licenceExpired = licenceExpirationDate && licenceExpirationDate < new Date();

  const licenceSoonExpired = !licenceExpired && licenceExpirationDate && licenceExpirationDate < new Date(new Date().setDate(new Date().getDate() + 30));

  const acceptsNewPrice = formHookNew.watch("acceptsNewPrice");
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="ModuleConfiguratorForm">
        <Card>
          <Card.Header>Abonnemang</Card.Header>
          <Card.Body>
            <div className="row">
              <div className="col-lg-6">
                <Card>
                  <Card.Header>Nuvarande{licenceExpirationDate ? " (Huvudförfallodatum : " + licenceExpirationDate.toLocaleDateString("sv-SE") + ")" : ""}</Card.Header>
                  <Card.Body>
                    <Abonnemang formHook={formHookCurrent} isDisabled={true} hook={ref.current} />
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-6">
                <Card>
                  <Card.Header>Ändra till</Card.Header>
                  <Card.Body>
                    <Abonnemang formHook={formHookNew} onPriceChange={onPriceChange} currentHousingStock={currentHousingStock} />
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Card.Body>
        </Card>

        {priceDiff && priceDiff.priceDifferenceYear !== 0 && (
          <Card className="mt-4">
            <Card.Header>Tilläggsbetalning</Card.Header>
            <Card.Body>
              <Table hover={true} style={{ fontSize: "large" }}>
                <tbody>
                  <tr>
                    <td>Prisskillnad per år</td>
                    <td style={{ textAlign: "right" }}>{numberFormatter.format(priceDiff.priceDifferenceYear) + " kr"}</td>
                  </tr>
                  <tr>
                    <td>Tilläggsbetalning innevarande år</td>
                    <td style={{ textAlign: "right" }}>{(priceDiff.priceAdditionCurrentYear > 0 ? numberFormatter.format(priceDiff.priceAdditionCurrentYear) : 0) + " kr"}</td>
                  </tr>
                </tbody>
              </Table>

              <div className="row">
                <div className="col-12">
                  {canUpdateSubscription ? (
                    <CheckboxEditor
                      label="Jag godkänner att tilläggsbetalning debiteras på nästa faktura"
                      fieldName="acceptsNewPrice"
                      formHook={formHookNew}
                      options={{ required: "Du måste godkänna det nya priset!" }}
                    />
                  ) : (
                    <div style={{ color: Colors.RedMedium }}>Du kan inte ändra abonnemanget till mindre än ditt nuvarande bestånd</div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        )}
        <div>
          <div className="d-flex justify-content-between align-items-center p-3 ">
            <div>
              {licenceExpired && <div className="bg-danger p-2 border text-white">Er licens har löpt ut – vänligen kontakta QWTOOL för att förnya licensen</div>}
              {licenceSoonExpired && <div className="bg-warning p-2 border">Er licens löper snart ut – vänligen kontakta QWTOOL för att förnya licensen</div>}
              {(licenceExpired || licenceSoonExpired) && (
                <Table className="m-1 mt-2">
                  <tr>
                    <td className="fw-bold">Kontakt</td>
                    <td>Email</td>
                    <td>info@qwtool.se</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Telefon</td>
                    <td>072 250 93 00</td>
                  </tr>
                </Table>
              )}
            </div>

            <div>
              <ValidationSummaryMessages errors={errors} />
            </div>
            <div className="align-self-start">
              <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
                Avbryt
              </button>
              <button
                type="submit"
                className={acceptsNewPrice && !hasErrors ? "btn btn-success ms-2" : "btn btn-primary ms-2"}
                disabled={!(priceDiff && priceDiff.priceDifferenceYear) || !canUpdateSubscription}
              >
                Uppdatera abonnemang
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ChangeAbonnemang;
